import React from "react";
import { useSelector } from "react-redux";
import GoogleStackedBarChart from "../../../../components/charts/googleChart/googleChart";

const ZeroVisitsChart = () => {
  let { data_table: { rows = [], cols = [] } = {}, options } = useSelector(
    (state) => state.zeroVisits.chartData
  );

  return (
    <GoogleStackedBarChart
      width="1350px"
      height={400}
      rows={rows}
      chartName="ColumnChart"
      columns={cols}
      options={options}
      enableEventListeners={false}
      showCurrency={false}
      showAdditionTooltip={false}
    />
  );
};

export default ZeroVisitsChart;
